import { CareerCategory, CareerPath } from '@backrs_ui/common-ui';

import { CareerPathWithScore } from '@backrs_ui/grow-ui/src/models/models';

import { Box, SxProps, Theme } from '@mui/material';

import { AllCareerPaths } from './molecules/careerPathPage/AllCareerPaths';
import { CareerPathHeader } from './molecules/careerPathPage/CareerPathHeader';
import { StrongFitPaths } from './molecules/careerPathPage/StrongFitPaths';

type CareerPathPageProps = Readonly<{
  careerCategories: CareerCategory[];
  careerPaths: CareerPath[];
  careerPathSuggestions: CareerPathWithScore[] | undefined;
  userHasBlueprint: boolean;
  isShared?: boolean;
}>;

export const CareerPathPage = ({
  careerCategories,
  careerPaths,
  careerPathSuggestions,
  userHasBlueprint,
  isShared = false,
}: CareerPathPageProps) => {
  return (
    <Box sx={containerStyle}>
      <Box sx={contentContainerStyle}>
        <CareerPathHeader userHasBlueprint={userHasBlueprint} isShared={isShared} />

        <StrongFitPaths
          careerCategories={careerCategories}
          careerPaths={careerPaths}
          careerPathSuggestions={careerPathSuggestions}
          userHasBlueprint={userHasBlueprint}
          isShared={isShared}
        />

        <AllCareerPaths
          careerCategories={careerCategories}
          careerPaths={careerPaths}
          careerPathSuggestions={careerPathSuggestions}
          userHasBlueprint={userHasBlueprint}
          isShared={isShared}
        />
      </Box>
    </Box>
  );
};

const containerStyle: SxProps<Theme> = {
  flexGrow: 1,
  containerType: 'inline-size',
  width: '100%',
  maxWidth: '100%',
  boxSizing: 'border-box',
};

const contentContainerStyle: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  maxWidth: '100%',
  pb: backrs.spacing['spacing-xl'],
  gap: backrs.spacing['spacing-2xl'],
  '@container (min-width: 600px)': {
    gap: backrs.spacing['spacing-3xl'],
  },
  '@container (min-width: 900px)': {
    gap: backrs.spacing['spacing-4xl'],
  },
});
